export function inputStyling(input: boolean) {
    return `${input ? 'ring-red-400' : 'ring-gray-200'} ring-2 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm rounded-md`;
}
